import { render, staticRenderFns } from "./CallHistory.vue?vue&type=template&id=a77f554e&scoped=true"
import script from "./CallHistory.vue?vue&type=script&lang=js"
export * from "./CallHistory.vue?vue&type=script&lang=js"
import style0 from "./CallHistory.vue?vue&type=style&index=0&id=a77f554e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a77f554e",
  null
  
)

export default component.exports